export default "__VITE_ASSET__CLarraCi__"